/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedPromptsIndexRouteImport } from './routes/_authenticated/prompts/index'
import { Route as AuthenticatedSettingsTagsRouteImport } from './routes/_authenticated/settings/tags'
import { Route as AuthenticatedSettingsCategoriesRouteImport } from './routes/_authenticated/settings/categories'
import { Route as AuthenticatedPromptsNewRouteImport } from './routes/_authenticated/prompts/new'
import { Route as AuthenticatedPromptsIdRouteImport } from './routes/_authenticated/prompts/$id'
import { Route as AuthenticatedPromptsIdEditRouteImport } from './routes/_authenticated/prompts/$id/edit'

const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPromptsIndexRoute =
  AuthenticatedPromptsIndexRouteImport.update({
    id: '/prompts/',
    path: '/prompts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsTagsRoute =
  AuthenticatedSettingsTagsRouteImport.update({
    id: '/settings/tags',
    path: '/settings/tags',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsCategoriesRoute =
  AuthenticatedSettingsCategoriesRouteImport.update({
    id: '/settings/categories',
    path: '/settings/categories',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPromptsNewRoute = AuthenticatedPromptsNewRouteImport.update({
  id: '/prompts/new',
  path: '/prompts/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPromptsIdRoute = AuthenticatedPromptsIdRouteImport.update({
  id: '/prompts/$id',
  path: '/prompts/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPromptsIdEditRoute =
  AuthenticatedPromptsIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedPromptsIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/prompts/$id': typeof AuthenticatedPromptsIdRouteWithChildren
  '/prompts/new': typeof AuthenticatedPromptsNewRoute
  '/settings/categories': typeof AuthenticatedSettingsCategoriesRoute
  '/settings/tags': typeof AuthenticatedSettingsTagsRoute
  '/prompts': typeof AuthenticatedPromptsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/prompts/$id/edit': typeof AuthenticatedPromptsIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/prompts/$id': typeof AuthenticatedPromptsIdRouteWithChildren
  '/prompts/new': typeof AuthenticatedPromptsNewRoute
  '/settings/categories': typeof AuthenticatedSettingsCategoriesRoute
  '/settings/tags': typeof AuthenticatedSettingsTagsRoute
  '/prompts': typeof AuthenticatedPromptsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/prompts/$id/edit': typeof AuthenticatedPromptsIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/_authenticated/prompts/$id': typeof AuthenticatedPromptsIdRouteWithChildren
  '/_authenticated/prompts/new': typeof AuthenticatedPromptsNewRoute
  '/_authenticated/settings/categories': typeof AuthenticatedSettingsCategoriesRoute
  '/_authenticated/settings/tags': typeof AuthenticatedSettingsTagsRoute
  '/_authenticated/prompts/': typeof AuthenticatedPromptsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/prompts/$id/edit': typeof AuthenticatedPromptsIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/prompts/$id'
    | '/prompts/new'
    | '/settings/categories'
    | '/settings/tags'
    | '/prompts'
    | '/settings'
    | '/prompts/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/sign-up'
    | '/prompts/$id'
    | '/prompts/new'
    | '/settings/categories'
    | '/settings/tags'
    | '/prompts'
    | '/settings'
    | '/prompts/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/sign-in'
    | '/sign-up'
    | '/_authenticated/prompts/$id'
    | '/_authenticated/prompts/new'
    | '/_authenticated/settings/categories'
    | '/_authenticated/settings/tags'
    | '/_authenticated/prompts/'
    | '/_authenticated/settings/'
    | '/_authenticated/prompts/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/prompts/': {
      id: '/_authenticated/prompts/'
      path: '/prompts'
      fullPath: '/prompts'
      preLoaderRoute: typeof AuthenticatedPromptsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/tags': {
      id: '/_authenticated/settings/tags'
      path: '/settings/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof AuthenticatedSettingsTagsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/categories': {
      id: '/_authenticated/settings/categories'
      path: '/settings/categories'
      fullPath: '/settings/categories'
      preLoaderRoute: typeof AuthenticatedSettingsCategoriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/prompts/new': {
      id: '/_authenticated/prompts/new'
      path: '/prompts/new'
      fullPath: '/prompts/new'
      preLoaderRoute: typeof AuthenticatedPromptsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/prompts/$id': {
      id: '/_authenticated/prompts/$id'
      path: '/prompts/$id'
      fullPath: '/prompts/$id'
      preLoaderRoute: typeof AuthenticatedPromptsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/prompts/$id/edit': {
      id: '/_authenticated/prompts/$id/edit'
      path: '/edit'
      fullPath: '/prompts/$id/edit'
      preLoaderRoute: typeof AuthenticatedPromptsIdEditRouteImport
      parentRoute: typeof AuthenticatedPromptsIdRoute
    }
  }
}

interface AuthenticatedPromptsIdRouteChildren {
  AuthenticatedPromptsIdEditRoute: typeof AuthenticatedPromptsIdEditRoute
}

const AuthenticatedPromptsIdRouteChildren: AuthenticatedPromptsIdRouteChildren =
  {
    AuthenticatedPromptsIdEditRoute: AuthenticatedPromptsIdEditRoute,
  }

const AuthenticatedPromptsIdRouteWithChildren =
  AuthenticatedPromptsIdRoute._addFileChildren(
    AuthenticatedPromptsIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedPromptsIdRoute: typeof AuthenticatedPromptsIdRouteWithChildren
  AuthenticatedPromptsNewRoute: typeof AuthenticatedPromptsNewRoute
  AuthenticatedSettingsCategoriesRoute: typeof AuthenticatedSettingsCategoriesRoute
  AuthenticatedSettingsTagsRoute: typeof AuthenticatedSettingsTagsRoute
  AuthenticatedPromptsIndexRoute: typeof AuthenticatedPromptsIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedPromptsIdRoute: AuthenticatedPromptsIdRouteWithChildren,
  AuthenticatedPromptsNewRoute: AuthenticatedPromptsNewRoute,
  AuthenticatedSettingsCategoriesRoute: AuthenticatedSettingsCategoriesRoute,
  AuthenticatedSettingsTagsRoute: AuthenticatedSettingsTagsRoute,
  AuthenticatedPromptsIndexRoute: AuthenticatedPromptsIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
